"use strict";
/*!
 * form-validate.js
 *
 * (c) 2019 Joshua Uyi
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable: variable-name

var validate_js_1 = __importDefault(require("validate.js"));

var form_control_1 = __importDefault(require("./form-control"));

var validate = validate_js_1["default"];
validate.Promise = Promise;
var customAsyncTasks = {};
var ASYNC_RESET_INDICATOR = '___ASYNC_RESET_INDICATOR_UNIQUE_STRING___';
var synchronousValidation = true;
var instanceCount = 0;

validate.validators.custom = function (value, options, key, attributes) {
  if (!options) {
    return null;
  }

  if (typeof options !== 'object') {
    options = {
      message: options
    };
  }

  return options.message || null;
};

validate.validators.customAsync = function (value, options, key, attributes, globalOptions) {
  if (synchronousValidation) {
    return null;
  }

  var asyncFuncKey = key + globalOptions.instanceCount;

  if (customAsyncTasks[asyncFuncKey]) {
    customAsyncTasks[asyncFuncKey]();
    delete customAsyncTasks[asyncFuncKey];
  }

  return new validate.Promise(function (resolve, reject) {
    customAsyncTasks[asyncFuncKey] = function () {
      reject(ASYNC_RESET_INDICATOR);
    };

    if (typeof options === 'function') {
      options(resolve);
    } else {
      resolve(options);
    }
  });
};

var FormValidate = function () {
  function FormValidate(rules, options, defaultValues) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    if (defaultValues === void 0) {
      defaultValues = {};
    }

    this.controls = {};
    this.options = {};
    this.considered = [];
    this.rules = {};
    this.customRuleKeys = [];
    this.customAsyncRuleKeys = [];
    this._values = {};
    this._valid = true;
    this._renderCallback = null;
    /**
     * @deprecated
     */

    this._reactComponent = null;

    this.callRender = function () {
      if (_this._renderCallback) {
        _this._renderCallback(_this._valid, _this.controls);
      }
    };

    this.options = __assign(__assign({}, options), {
      instanceCount: ++instanceCount
    });

    this._addMultipleControls(Object.keys(rules), __assign({}, rules), __assign({}, defaultValues));
  }

  FormValidate.prototype.addControl = function (controlName, rule, defaultValue) {
    var _a, _b;

    if (defaultValue === void 0) {
      defaultValue = '';
    }

    this._addMultipleControls([controlName], (_a = {}, _a[controlName] = rule, _a), (_b = {}, _b[controlName] = defaultValue, _b));
  };

  FormValidate.prototype.removeControl = function (controlName) {
    if (!this.considered.includes(controlName)) {
      return;
    }

    delete this.rules[controlName];
    delete this.controls[controlName];
    delete this._values[controlName];
    this.considered = this.considered.filter(function (item) {
      return item !== controlName;
    });
    this.customRuleKeys = this.customRuleKeys.filter(function (item) {
      return item !== controlName;
    });
    this.customAsyncRuleKeys = this.customAsyncRuleKeys.filter(function (item) {
      return item !== controlName;
    });
    this.updateValidState();
  };

  FormValidate.prototype.get = function (controlName) {
    return this.controls[controlName] || null;
  };

  FormValidate.prototype.getControls = function () {
    return this.controls;
  };

  FormValidate.prototype.values = function () {
    return this._values;
  };
  /**
   * @deprecated
   */


  FormValidate.prototype.getValid = function () {
    return this.isValid();
  };
  /**
   * @deprecated
   */


  FormValidate.prototype.isValid = function () {
    return this.valid();
  };

  FormValidate.prototype.valid = function () {
    return this._valid;
  };

  FormValidate.prototype.invalid = function () {
    return !this._valid;
  };

  FormValidate.prototype.touch = function (controlName, callback) {
    this.controls[controlName].setTouched(true);
    this.callRender();
  };
  /**
   *
   * @param callback - callback param is deprecated and will be removed, use the render(callback) method
   */


  FormValidate.prototype.touchAll = function (callback) {
    if (callback === void 0) {
      callback = null;
    }

    this._toggleTouchedWithCallback(true, callback);
  };
  /**
   *
   * @param callback - callback param is deprecated and will be removed, use the render(callback) method
   */


  FormValidate.prototype.unTouchAll = function (callback) {
    if (callback === void 0) {
      callback = null;
    }

    this._toggleTouchedWithCallback(false, callback);
  };
  /**
   * @param component
   * @deprecated
   */


  FormValidate.prototype.setReactComponent = function (component) {
    if (!component.setState) {
      return;
    }

    this._reactComponent = component;
  };

  FormValidate.prototype.render = function (callback) {
    if (callback === void 0) {
      callback = null;
    }

    this._renderCallback = callback;
  };

  FormValidate.prototype.reset = function () {
    for (var _i = 0, _a = this.considered; _i < _a.length; _i++) {
      var controlName = _a[_i];
      this.controls[controlName].setErrors([]).setLoading(false).setTouched(false);
    }

    this._valid = false;
    this.callRender();
  };

  FormValidate.prototype.updateValues = function (values) {
    for (var _i = 0, _a = this.considered; _i < _a.length; _i++) {
      var key = _a[_i];

      if (values[key] !== undefined) {
        this._values[key] = values[key];
      }
    }

    this._syncRevalidate(this.considered, this._values, this.rules);
  };

  FormValidate.prototype.validate = function (nativeEvent, callback) {
    var _this = this;

    if (callback === void 0) {
      callback = null;
    }

    setTimeout(function () {
      var _a;

      var target = nativeEvent.target;
      var control = target || {};
      var type = control.type;
      var name = control.name,
          value = control.value;
      var formControlAttrName;

      if (control.getAttribute) {
        formControlAttrName = control.getAttribute('data-validate-control') || control.getAttribute('validate-control');
      } else {
        var formControl = control["validate-control"],
            dataFormControl = control["data-validate-control"];
        formControlAttrName = dataFormControl || formControl;
      }

      name = formControlAttrName || name;

      if (_this.considered.indexOf(name) < 0) {
        return;
      }

      var controlIsLoading = false;

      if (type === 'checkbox' && !control.checked) {
        value = null;
      }

      _this._values = __assign(__assign({}, _this._values), (_a = {}, _a[name] = value, _a));

      var toValidateRules = __assign({}, _this.rules); // only process async validator of field currently edited, mark others as false


      for (var _i = 0, _b = _this.customAsyncRuleKeys; _i < _b.length; _i++) {
        var asyncValidatorKey = _b[_i];

        if (asyncValidatorKey !== name) {
          toValidateRules[asyncValidatorKey] = __assign(__assign({}, toValidateRules[asyncValidatorKey]), {
            customAsync: null
          });
        }
      } // place control in error mode if it has an async validation


      if (_this.rules[name].hasOwnProperty('customAsync')) {
        _this.controls[name].setLoading(true);

        _this.updateValidState(); // TODO: deprecated, remove logic


        if (_this._reactComponent) {
          _this._reactComponent.setState({});
        } //


        if (callback) {
          callback(_this._valid, _this.controls);
        }
      }

      var foundErrors = {};
      validate.async(_this._values, toValidateRules, _this.options).then(function () {
        _this.controls[name].setTouched(true).setErrors([]);
      })["catch"](function (err) {
        if (err instanceof Error) {
          throw err;
        }

        if (err === ASYNC_RESET_INDICATOR) {
          controlIsLoading = true;

          _this.controls[name].setLoading(true);

          return;
        }

        foundErrors = err || {}; // validate currently change field

        _this.controls[name].setTouched(true).setErrors(foundErrors[name] || []);
      })["finally"](function () {
        // update errors of all customRule fields
        for (var _i = 0, _a = _this.customRuleKeys; _i < _a.length; _i++) {
          var key = _a[_i];

          _this.controls[key].setTouched(true).setErrors(foundErrors[key] || []);
        }

        _this.controls[name].setLoading(controlIsLoading);

        _this.updateValidState(); // TODO: deprecated, remove logic


        if (_this._reactComponent) {
          _this._reactComponent.setState({}, function () {
            if (callback) {
              callback(_this._valid, _this.controls);
            }
          });
        } //


        if (callback) {
          callback(_this._valid, _this.controls);
        }

        _this.callRender();
      });
    }, 0);
  };

  FormValidate.prototype.updateValidState = function () {
    for (var _i = 0, _a = this.considered; _i < _a.length; _i++) {
      var key = _a[_i];

      if (this.controls[key].hasError() || this.controls[key].isLoading()) {
        this._valid = false;
        return;
      }
    }

    this._valid = true;
    this.callRender();
  };

  FormValidate.prototype._addMultipleControls = function (controlNames, rules, defaultValues) {
    if (defaultValues === void 0) {
      defaultValues = {};
    }

    this.considered = __spreadArrays(this.considered, controlNames);
    this.rules = __assign(__assign({}, this.rules), rules);

    for (var _i = 0, controlNames_1 = controlNames; _i < controlNames_1.length; _i++) {
      var key = controlNames_1[_i];
      this._values[key] = defaultValues[key] || null;
      this.controls[key] = new form_control_1["default"]();

      if (this.rules[key].custom && Object.keys(this.rules[key]).length === 1) {
        this.customRuleKeys.push(key);
      }

      if (this.rules[key].presence) {
        if (this.rules[key].presence === true) {
          this.rules[key].presence = {
            allowEmpty: false
          };
        } else if (typeof this.rules[key].presence === 'object') {
          this.rules[key].presence = __assign({
            allowEmpty: false
          }, this.rules[key].presence);
        }
      }

      if (this.rules[key].customAsync) {
        this.customAsyncRuleKeys.push(key);
      }
    } // validate all fields


    this._syncRevalidate(controlNames, defaultValues, rules);
  };

  FormValidate.prototype._syncRevalidate = function (controls, values, rules) {
    synchronousValidation = true;
    var validationErrors = validate(values, rules, this.options) || {};
    synchronousValidation = false;

    for (var _i = 0, controls_1 = controls; _i < controls_1.length; _i++) {
      var controlKey = controls_1[_i];
      this.controls[controlKey].setErrors(validationErrors[controlKey] || []);
    }

    this.updateValidState();
  };

  FormValidate.prototype._toggleTouchedWithCallback = function (touchedState, callback) {
    var _this = this;

    if (callback === void 0) {
      callback = null;
    }

    for (var _i = 0, _a = this.considered; _i < _a.length; _i++) {
      var controlKey = _a[_i];
      this.controls[controlKey].setTouched(touchedState);
    } // TODO: deprecated, remove logic


    if (this._reactComponent) {
      this._reactComponent.setState({}, function () {
        if (callback) {
          callback(_this._valid, _this.controls);
        }
      });
    }

    if (callback) {
      callback(this._valid, this.controls);
    }

    this.callRender();
  };

  return FormValidate;
}();

window.FormValidate = FormValidate;
exports["default"] = FormValidate;